import axios from 'axios'
import swal from 'sweetalert'

export default {
  methods: {
    async deleteConfirmingUnlink({
      url, name, successMessage, onDeleted,
    }) {
      const confirmed = await swal({
        title: `Excluir "${name}"?`,
        text: 'Esta ação não pode ser desfeita.',
        icon: 'warning',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      })
      if (!confirmed) return

      await this.sendUnlinkDelete({
        url, name, successMessage, onDeleted,
      }, false)
    },

    async sendUnlinkDelete({
      url, name, successMessage, onDeleted,
    }, confirmUnlink) {
      this.$loading(true)
      try {
        await axios.delete(url, { params: confirmUnlink ? { confirm_unlink: 1 } : {} })
        this.$message('Sucesso', successMessage, 'success')
        await onDeleted()
      } catch (e) {
        const data = (e.response && e.response.data) || {}
        const needsConfirm = e.response && e.response.status === 409
          && Array.isArray(data.establishments) && !confirmUnlink

        if (!needsConfirm) {
          this.$message(null, data.message || data, 'error')
          return
        }

        this.$loading(false)
        const lista = data.establishments.map(est => `• ${est.name}`).join('\n')
        const ok = await swal({
          title: `Excluir "${name}" e desvincular?`,
          text: `Os estabelecimentos abaixo deixarão de atender "${name}" e não aparecerão mais no filtro de destino por esse item:\n\n${lista}\n\nSe a intenção é só tirar de uso, prefira inativar.`,
          icon: 'warning',
          buttons: ['Cancelar', 'Excluir e desvincular'],
          dangerMode: true,
        })
        if (ok) {
          await this.sendUnlinkDelete({
            url, name, successMessage, onDeleted,
          }, true)
        }
      } finally {
        this.$loading(false)
      }
    },
  },
}
